import { register } from '@maxsystems/ui/mixins/pluggable'

import Appointments from './Appointments'
import SavedCars from './SavedCars'

register('board', Appointments)
register('board', SavedCars)
